module.exports = __webpack_public_path__ + "assets/img/32_630_big.22435480.jpg";